import { render, staticRenderFns } from "./courseEdit_new.vue?vue&type=template&id=701c55c6&scoped=true"
import script from "./courseEdit_new.vue?vue&type=script&lang=js"
export * from "./courseEdit_new.vue?vue&type=script&lang=js"
import style0 from "./courseEdit_new.vue?vue&type=style&index=0&id=701c55c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701c55c6",
  null
  
)

export default component.exports